export default function nice_name(name) {
  return (
    name &&
    name
      .toLocaleString()
      .replace(/\s*\(.\)/, "")
      .replace(/[\/,\s]/g, "_")
  );
}



// WEBPACK FOOTER //
// ./utils/simplifyName.js